import styled, { css, RuleSet } from 'styled-components'
import React, { ReactNode, MouseEvent } from 'react'
import {
  Noto_body1_b16,
  Noto_body2_b14,
  Noto_body2_m14,
  Noto_body3_b12,
  Noto_body3_m12,
} from 'src/styles/fonts/NotoSansKrFonts'

export interface ButtonProps {
  children: ReactNode
  option: RuleSet<object>
  style?: RuleSet<object>
  onClickFn?: (event: MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  className?: string
}

const Button = ({ children, option, onClickFn, disabled, style, className }: ButtonProps) => {
  return (
    <ButtonWrap
      $option={option}
      onClick={onClickFn}
      disabled={disabled}
      $style={style}
      className={className}
    >
      {children}
    </ButtonWrap>
  )
}
export default Button

const ButtonWrap = styled.button<{ $option: RuleSet; $width?: string; $style?: RuleSet<object> }>`
  width: 100%;
  cursor: pointer;
  ${(props) => props.$option};
  ${(props) => props.$style};
`

const ButtonOption1 = (option: 'default' | 'active') => css`
  border-radius: 8px;
  height: 38px;
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 10px;

  ${option === 'active' &&
  css`
    color: var(--brand-50);
    background-color: var(--brand-10);
    border: none;
    ${Noto_body2_b14}
  `}
  ${option === 'default' &&
  css`
    color: var(--black-60);
    border: 1px solid var(--black-10);
    background: var(--white);
    ${Noto_body2_m14};
  `}
  
  &:disabled {
    border-radius: 8px;
    ${Noto_body2_m14};
    color: var(--black-30);
    border: 1px solid var(--black-6);
    background: var(--black-2);
  }
`

const ButtonOption2 = (option: 'default' | 'strong' | 'dark') => css`
  height: 30px;

  ${option === 'default' &&
  css`
    ${Noto_body2_m14};
    color: var(--black-30);
  `}
  ${option === 'strong' &&
  css`
    ${Noto_body2_b14};
    color: var(--black-50);
  `}
  ${option === 'dark' &&
  css`
    ${Noto_body2_m14};
    color: var(--black-50);
  `}
`

const ButtonOption3 = (option: 'default' | 'active' | 'outline') => css`
  ${Noto_body1_b16};
  height: 48px;
  border-radius: 12px;

  ${option === 'active' &&
  css`
    background-color: var(--brand-50);
    color: var(--white);
  `}
  ${option === 'outline' &&
  css`
    background-color: var(--white);
    color: var(--brand-50);
    border: 1px solid var(--black-20);
  `}
  ${option === 'default' &&
  css`
    background-color: var(--brand-10);
    color: var(--brand-50);
  `}
  &:disabled {
    background-color: var(--black-10);
    color: var(--black-30);
  }
`

const ButtonOption4 = css`
  height: 56px;
  border-radius: 14px;
  background-color: var(--brand-50);
  color: var(--white);
  ${Noto_body3_b12};
`

// 현재 미사용
const ButtonOption5 = css`
  height: 30px;
  color: var(--black-50);
  ${Noto_body2_b14}
`

const ButtonOption6 = (option: 'default' | 'active') => css`
  height: 30px;
  border-radius: 8px;
  ${option === 'default' &&
  css`
    color: var(--black-60);
    border: 1px solid var(--black-10);
    background: var(--white);
    ${Noto_body3_m12};
  `}
  ${option === 'active' &&
  css`
    color: var(--brand-50);
    background-color: var(--brand-10);
    ${Noto_body3_b12};
  `}
`

const ButtonOption7 = (option: 'default' | 'black') => css`
  height: 48px;
  border-radius: 12px;
  ${Noto_body1_b16};
  ${option === 'default' &&
  css`
    color: var(--white);
    background: var(--black-90);
  `}
  ${option === 'black' &&
  css`
    color: var(--white);
    background: var(--black-100);
  `}
  &:disabled {
    background-color: var(--black-4);
    color: var(--black-20);
  }
`

export {
  ButtonOption3,
  ButtonOption1,
  ButtonOption2,
  ButtonOption4,
  ButtonOption5,
  ButtonOption6,
  ButtonOption7,
}
